import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { api } from "../../lib/api";

export const Testimonials = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/testimonials").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  if (items.length === 0) return null;
  return (
    <section className="bg-paper text-ink py-24 md:py-32" aria-labelledby="testimonials-title" data-testid="testimonials-section">
      <div className="max-w-6xl mx-auto px-6">
        <p className="lbl text-teal">From families</p>
        <h2 id="testimonials-title" className="font-display mt-4 max-w-2xl">In their words</h2>
        <div className="mt-14 grid md:grid-cols-2 gap-10 items-start">
          {items.map((t, i) => (
            <figure key={t.id} className={`relative bg-cream rounded-2xl p-8 md:p-10 border-l-4 border-brass ${i % 2 ? "md:mt-16" : ""}`} data-testid={`testimonial-${i}`}>
              <Quote className="w-8 h-8 text-teal" aria-hidden="true" />
              <blockquote className="mt-4 font-display text-xl md:text-2xl leading-snug">“{t.quote}”</blockquote>
              <figcaption className="mt-6 lbl text-slate">{t.name}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
